import { formatTodaysDate } from "../utils";
import { getGiftState, updateGiftState } from "./utils";

export function hasSendGiftButtonBeenClickedToday() {
  const today = formatTodaysDate();
  const { lastDateClickedSendGiftButton } = getGiftState();

  return lastDateClickedSendGiftButton === today;
}

export function clickSendGiftButton() {
  updateGiftState({
    lastDateClickedSendGiftButton: formatTodaysDate()
  });
}

export function hasGiftAlreadyBeenReceived(date: string) {
  const { datesGiftsGiven } = getGiftState();

  return datesGiftsGiven?.includes(date);
}

export function receiveGift(date: string) {
  if (hasGiftAlreadyBeenReceived(date)) {
    return;
  }

  const { datesGiftsGiven = [], numExamQuestionGifts = 0 } = getGiftState();

  updateGiftState({
    datesGiftsGiven: [...datesGiftsGiven, date],
    numExamQuestionGifts: numExamQuestionGifts + 1
  });
}

export function getNumExamQuestionGifts() {
  const { numExamQuestionGifts } = getGiftState();
  return numExamQuestionGifts ?? 0;
}

export function hasExamQuestionGift() {
  const count = getNumExamQuestionGifts();
  return count && count > 0;
}

export function decrementExamQuestionsGiftCount() {
  const count = getNumExamQuestionGifts();

  updateGiftState({
    numExamQuestionGifts: Math.max((count ?? 0) - 1, 0)
  });
}
